var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 5.41658C9.16634 4.95635 8.79325 4.58325 8.33301 4.58325C7.87277 4.58325 7.49967 4.95635 7.49967 5.41658V7.49992H5.41634C4.9561 7.49992 4.58301 7.87301 4.58301 8.33325C4.58301 8.79349 4.9561 9.16658 5.41634 9.16658H7.49967V11.2499C7.49967 11.7102 7.87277 12.0833 8.33301 12.0833C8.79325 12.0833 9.16634 11.7102 9.16634 11.2499V9.16658H11.2497C11.7099 9.16658 12.083 8.79349 12.083 8.33325C12.083 7.87301 11.7099 7.49992 11.2497 7.49992H9.16634V5.41658Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33301 0.833252C4.19087 0.833252 0.833008 4.19112 0.833008 8.33325C0.833008 12.4754 4.19087 15.8333 8.33301 15.8333C10.1039 15.8333 11.7314 15.2195 13.0144 14.1932L16.9104 18.0892C17.2359 18.4146 17.7635 18.4146 18.0889 18.0892C18.4144 17.7637 18.4144 17.2361 18.0889 16.9107L14.1929 13.0147C15.2193 11.7316 15.833 10.1041 15.833 8.33325C15.833 4.19112 12.4751 0.833252 8.33301 0.833252ZM2.49967 8.33325C2.49967 5.11159 5.11135 2.49992 8.33301 2.49992C11.5547 2.49992 14.1663 5.11159 14.1663 8.33325C14.1663 11.5549 11.5547 14.1666 8.33301 14.1666C5.11135 14.1666 2.49967 11.5549 2.49967 8.33325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.9780ffd0d77c1873b5a726fc0b358d81.svg";
export { ForwardRef as ReactComponent };